import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import { DueDiligencePageGetDueDiligenceFunnelQuery, DueDiligencePageListUsersQuery, Role } from '@/__generated__/graphql';
import { useAuth } from '@/hooks/use-auth';
import ModalWrappedContent from '../basicComponents/modal/modalWrappedContent';
import Select, { ISelectValue } from '../basicComponents/select';
import { createSimpleSelectOption } from '../basicComponents/select/utils';
import { LIST_USERS_QUERY } from './queries';

interface EditOwnerProps {
  row: DueDiligencePageGetDueDiligenceFunnelQuery['getDueDiligenceFunnel']['tiers'][number]['records'][number] | null;
  isOpen: boolean;
  updateOwner: (variables: any) => void;
  onClose: () => void;
}

const EditOwner = ({ row, isOpen, updateOwner, onClose }: EditOwnerProps) => {
  const { user } = useAuth();

  const [ownerSelectOptions, setOwnerSelectOptions] = useState<ISelectValue[]>([]);
  const [ownerEmail, setOwnerEmail] = useState('');

  useEffect(() => {
    if (!row) return;

    setOwnerEmail(row?.owner?.email || '');
  }, [row]);

  const { loading: listUsersLoading } = useQuery(LIST_USERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      filters: {
        roles: [Role.InvestmentLead, Role.InvestmentMember],
        tenantId: user.tenant.id
      }
    },
    onCompleted: (data) => {
      const selectOptions = data?.listUsers?.map((user: DueDiligencePageListUsersQuery['listUsers'][number]) =>
        createSimpleSelectOption(user.email, `${user.firstName} ${user.lastName}`)
      );
      setOwnerSelectOptions(selectOptions);
    }
  });

  const saveSelectors = () => {
    if (row?.owner?.email === ownerEmail) {
      onClose();
      return;
    }

    updateOwner({
      variables: {
        data: {
          id: row.id,
          ownerEmail,
          investmentId: row.investment?.id
        }
      }
    });
    onClose();
  };

  if (!row) return <></>;

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Owner"
      confirmButton={{ name: 'Save', onClick: saveSelectors }}
      showRequiredFields
    >
      <Select
        label="Owner"
        value={ownerEmail}
        setValue={setOwnerEmail}
        options={ownerSelectOptions}
        loading={listUsersLoading}
        size="lg"
        isRequiredField
      />
    </ModalWrappedContent>
  );
};

export default EditOwner;
